import { useMemo } from 'react';
import MobileDownloadPageBase from '../../components/common/MobileDownloadPageBase';
import MobileHeader from '../../components/common/MobileHeader';
import MobileFooter from '../../components/common/MobileFooter';
import { ErrorMessages } from '../../components/tmobile/ErrorCodes';

/**
 * T-Mobile mobile app download page
 * Wrapper around generic MobileDownloadPageBase with T-Mobile-specific configuration
 */
export default function TMobileDownloadPage() {
  const config = useMemo(() => ({
    partnerName: 'T-Mobile',
    affiliateId: process.env.REACT_APP_TMOBILE_AFFILIATE_ID,
    brandingId: process.env.REACT_APP_TMOBILE_BRANDING_ID,
    analyticsId: process.env.REACT_APP_TMOBILE_GOOGLE_ANALYTICS_ID,
    supportedPlatformsEnvVar: 'REACT_APP_TMOBILE_SUPPORTED_PLATFORMS',
    urlConfig: {
      android: process.env.REACT_APP_TMOBILE_ANDROID_STORE_URL,
      iphone: process.env.REACT_APP_TMOBILE_IOS_STORE_URL,
    },
    errorCodeMap: {
      invalid_platform: 'T-001',
      unsupported_platform: 'T-002',
      download_failed: 'T-003',
      unexpected_error: 'T-004',
      network_error: 'T-005',
    },
  }), []);

  return (
    <MobileDownloadPageBase
      HeaderComponent={MobileHeader}
      FooterComponent={MobileFooter}
      config={config}
      errorMessages={ErrorMessages}
      pageTitle="Download McAfee Security for T-Mobile"
      pageSubtitle="Protect your mobile device. Select your device type to download now."
      disclaimer="By downloading this app, you agree to McAfee's Terms of Service and Privacy Policy."
    />
  );
}
